import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Reducer } from 'redux';
import { RootState } from '../../@types/RootState';
import { SET_PRECO_ATACADO_FILTERS_VALUE, UPDATE_PRECO_ATACADO_FILTERS_VALUE } from './filters/values';

export type PrecoAtacadoPaginationState = {
  activePage: number;
  displayLength: number;
};

const initialState: PrecoAtacadoPaginationState = {
  activePage: 0,
  displayLength: 25,
};

const slice = createSlice({
  name: 'ipa/precoAtacado/pagination',
  initialState,
  reducers: {
    SET_PRECO_ATACADO_PAGINATION: (_state, { payload }: PayloadAction<{ activePage: number; displayLength: number }>) => payload,
    UPDATE_PRECO_ATACADO_PAGINATION: (state, { payload }: PayloadAction<Partial<PrecoAtacadoPaginationState>>) => {
      return {
        ...state,
        ...payload,
      };
    },
    SET_PRECO_ATACADO_DISPLAY_LENGTH: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        displayLength: payload,
      };
    },
    SET_PRECO_ATACADO_ACTIVE_PAGE: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        activePage: payload,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(SET_PRECO_ATACADO_FILTERS_VALUE, state => {
        state.activePage = 0;
      })
      .addCase(UPDATE_PRECO_ATACADO_FILTERS_VALUE, state => {
        state.activePage = 0;
      });
  },
});

export const selectorPrecoAtacadoPagination = (state: RootState) => {
  return state.precoAtacadoReducer.pagination;
};

export const { SET_PRECO_ATACADO_PAGINATION, UPDATE_PRECO_ATACADO_PAGINATION, SET_PRECO_ATACADO_DISPLAY_LENGTH, SET_PRECO_ATACADO_ACTIVE_PAGE } = slice.actions;

const reducer: Reducer<PrecoAtacadoPaginationState> = slice.reducer;

export default reducer;
